module.exports = __webpack_public_path__ + "assets/magento.03477353.svg";